import React, {useMemo, useState, useEffect} from 'react';
import useI18n from 'i18n/useI18n';
import styled from 'styled-components';
import { PRIMARY, INPUTS, DISABLED_BUTTON  } from '@etiquette-ui/colors';

const DaysTranslation = {
  en: {
    SUNDAY: 'Sunday',
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
  },
  es: {
    SUNDAY: 'Domingo',
    MONDAY: 'Lunes',
    TUESDAY: 'Martes',
    WEDNESDAY: 'Miércoles',
    THURSDAY: 'Jueves',
    FRIDAY: 'Viernes',
    SATURDAY: 'Sábado',
  }
}

const Container = styled.div`
  .label {
    font-size: 14px;
    font-weight: 500;
    margin-top: -3px;
    margin-bottom: 7px;
    color: ${PRIMARY};
  }
`;
const DaysRow = styled.div`
  display: flex;
`;
const DayOption = styled.div`
  width: 38px;
  height: 30px;
  display: flex;
  font-size: 12px;
  user-select: none;
  margin-right: 5px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  color: ${({isActive, disabled}) => !!disabled ? DISABLED_BUTTON : !!isActive ? 'white' : 'black'};
  background-color: ${({isActive, disabled}) => !!disabled || !isActive ? INPUTS : PRIMARY};

  &:hover {
    cursor: ${({disabled}) => !!disabled ? 'not-allowed' : 'pointer'};
  }
`;

const DaysSelector = ({ 
  selectedDays = [],
  onChange = ()=>{},
  seedFullDays = false,
  disabledDays = [],
  containerClassName,
  allowDisabledBeMarked= false}) => {

  const { translateObject, translate, selectedLang } = useI18n();
  const [dayIndexes, setDayIndexes] = useState(selectedDays);

  useEffect(()=>{
    if(seedFullDays) {
      const seededDays = Object.keys(DaysTranslation.en);
      setDayIndexes(seededDays);
      onChange(seededDays);
    }
  },[seedFullDays]);

  const daysOptions = useMemo(()=>{
    return Object.entries(translateObject(DaysTranslation)).map( ([key,value]) => ({
      value: key,
      label: value[0]
    }));
  }, [selectedLang, selectedDays]);

  const onClick = ( dayIndex ) => {
    if(disabledDays.includes(dayIndex) && !allowDisabledBeMarked) return;

    let newIndexes = [...dayIndexes];
    if(newIndexes.includes(dayIndex)){      
      const currentIndex = newIndexes.indexOf(dayIndex);
      newIndexes.splice(currentIndex, 1);
      setDayIndexes(newIndexes);
    } else {
      newIndexes = [...newIndexes, dayIndex];
      setDayIndexes( newIndexes );
    }
    onChange(newIndexes)
  }

  const isActive = (day) => dayIndexes.includes(day);

  return (
    <Container className={`${containerClassName}`}>
      <div className='label'>{translate("Days")}</div>
      <DaysRow>
        {!!daysOptions && daysOptions.map( dayOption => (
          <DayOption
            onClick={()=>onClick(dayOption.value)}
            disabled={disabledDays.includes(dayOption.value) && !allowDisabledBeMarked} 
            isActive={ isActive(dayOption.value) }>
              {dayOption.label}
          </DayOption>
        ))}
      </DaysRow>
    </Container>
  )
}
export default DaysSelector;